import cryptoconvertor from "../assets/projectsimages/cryptoconvertor.jpg";
import ccdashboard from "../assets/projectsimages/ccdashboard.png"
import spotifyclone from "../assets/projectsimages/spotifyclone.png";
import resumebuilder from "../assets/projectsimages/resumebuilder.png";
import krupali from "../assets/projectsimages/krupali.png";
import flashcardgenerator from "../assets/projectsimages/flashcardgenerator.png";
import quizplatform from "../assets/projectsimages/quizplatform.png";
import whatstheweather from "../assets/projectsimages/whatstheweather.png";
import calculator from "../assets/projectsimages/calculator.png";
import sixtydayscode from "../assets/projectsimages/sixtydayscode.jpg";
import alarm from "../assets/projectsimages/alarm.png";
import mariomatching from "../assets/projectsimages/mariomatching.png";

export const projects = [
    {
        title: "Krupali Desai",
        description: "I have created my personal portfolio website to showcase my skills, projects, ecperience & more.",
        url: "https://krdesai02.netlify.app",
        img: krupali,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "React.js",
            "Sass",
            "Firebase"
        ],
        githuburl: "#"
    },
    {
        title: "Resume Builder",
        description: "Create your resume quickly using the free online tool known as Resume Builder",
        url: "https://resume-builder270.netlify.app/",
        img: resumebuilder,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "React.js",
            "Redux"
        
        ],
        githuburl: "https://github.com/dkrupali56/Resume-Builder"
    },
    {
        title: "Spotify Clone",
        description: "Clone of music website spotify with API through which a user can play songs.",
        url: "https://spotify-clone-56.netlify.app/",
        img: spotifyclone,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "MERN Stack"
        ],
        githuburl: "https://github.com/dkrupali56/Spotify-Clone"
    },
    {
        title: "Crypto Converter",
        description: "A app which converts a crypto currency and give ammount you will receive in other currency",
        url: "https://crypto-convertor1.netlify.app/",
        img: cryptoconvertor,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "React.js"
            
        ],
        githuburl: "https://github.com/dkrupali56/Crypto-Convertor"
    },
    {
        title: "Cryptocurrency Dashboard",
        description: "A simple Cryptocurrency Dashboard with crypto conversion functionality",
        url: "https://cryptocurrency-dashboard23.netlify.app/",
        img: ccdashboard,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "React.js"
        ],
        githuburl: "https://github.com/dkrupali56/Crypto-Currency-Dashboard"
    },
    {
        title: "Flashcard Generator",
        description: "A simple Flashcard Generator app with multifunctionality using React",
        url: "https://flashcard-generator20.netlify.app/",
        img: flashcardgenerator,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "React.js"
        ],
        githuburl: "https://github.com/dkrupali56/Flashcard-Generator"
    },
    {
        title: "Quiz Platform",
        description: "A simple Quiz Platform where user can take quiz, see past quiz, play quiz using React",
        url: "https://quiz-platform3.netlify.app/",
        img: quizplatform,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "React.js"
        ],
        githuburl: "https://github.com/dkrupali56/Quiz-Platform"
    },
    {
        title: "Calculator",
        description: "A app that performs arithmetic operations on numbers like addition, subtraction etc",
        url: "https://calculator-9.netlify.app/",
        img: calculator,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "React.js"

        ],
        githuburl: "https://github.com/dkrupali56/Calculator"
    },
    {
        title: "What's The Weather",
        description: "A website which is used to check the accureate realtime weather of any city in the world.",
        url: "https://weather-app37.netlify.app/",
        img: whatstheweather,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript",
            "React.js",
            "Rapid API"
            
        ],
        githuburl: "https://github.com/dkrupali56/Weather-App"
    },
    {
        title: "60-Days-Code",
        description: "I made small 60 projects using HTML, CSS and JavaScript which languages.",
        url: "https://github.com/dkrupali56/60-Days-Code",
        img: sixtydayscode,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript"
            
        ],
        githuburl: "https://dkrupali56.github.io/60-Days-Code/"
    },
    ,
    {
        title: "Alarm App",
        description: "An alarm clock to alert peoples from their sleep or set timer as reminder of any work.",
        url: "https://alarm3.netlify.app/",
        img: alarm,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript"
            
        ],
        githuburl: "https://github.com/dkrupali56/Alarm-App"
    },
    {
        title: "Mario Matching Game",
        description: "This game challenges players to match three identical images within a specified time limit.",
        url: "https://mario-matching-gamee1.netlify.app/",
        img: mariomatching,
        technologies: [
            "HTML",
            "CSS",
            "JavaScript"
            
        ],
        githuburl: "https://github.com/dkrupali56/Mario-Matching-Game"
    }
       
]
